export var SwitchCardState;
(function (SwitchCardState) {
    SwitchCardState["DEFAULT"] = "DEFAULT";
    SwitchCardState["DISABLED"] = "DISABLED";
    SwitchCardState["DISABLED_SELECTED"] = "DISABLED_SELECTED";
    SwitchCardState["LOADING"] = "LOADING";
    SwitchCardState["SELECTED"] = "SELECTED";
})(SwitchCardState || (SwitchCardState = {}));
export const switchCardStateIsLoading = (switchCardState) => switchCardState === SwitchCardState.LOADING;
export const switchCardStateIsSelected = (switchCardState) => switchCardState === SwitchCardState.SELECTED ||
    switchCardState === SwitchCardState.DISABLED_SELECTED;
/**
 * Determines the state of the SwitchCard based on its properties.
 *
 * @param checked - Whether the card is checked/selected.
 * @param loading - Whether the card is in a loading state.
 * @param disabled - Whether the card is disabled.
 * @returns The current state of the SwitchCard.
 */
export const getSwitchCardState = (checked = false, loading = false, disabled = false) => {
    if (loading) {
        return SwitchCardState.LOADING;
    }
    if (disabled) {
        return checked ? SwitchCardState.DISABLED_SELECTED : SwitchCardState.DISABLED;
    }
    return checked ? SwitchCardState.SELECTED : SwitchCardState.DEFAULT;
};
//# sourceMappingURL=state.js.map